import { useQuery } from '@tanstack/react-query';
import { fetchHistoricalAnalytics, type HistoricalAnalyticsRequest, type HistoricalAnalyticsResponse } from '@/utils/historicalAnalyticsAPI';

export function useHistoricalAnalytics(request: HistoricalAnalyticsRequest | null) {
  const result = useQuery<HistoricalAnalyticsResponse, Error>({
    queryKey: ['historicalAnalytics', request],
    queryFn: () => {
      if (!request) {
        throw new Error('No request provided');
      }
      return fetchHistoricalAnalytics(request);
    },
    enabled: !!request && !!request.periods && request.periods.length >= 2,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 2,
  });

  return result;
}
